<!--
@author: 赵静静
@time: 2021/10/27
@desc:  项目
-->
<template>
  <div style="display: flex;margin-bottom: 60px;">
    <div>
      <personalMenu :activeIndex="'4'"/>
    </div>
    <div class="project">
      <el-tabs @tab-click="tabClick" v-model="active">
        <el-tab-pane v-for="(item, index) in projectTitleList" :key="index" :label="item.title" :name="item.name">
          <div v-loading="loadingGoods">
            <div v-if="ifHasProduct">
              <div v-for="item in list" class="org-div">
                <div class="title">
                  <template v-if="active == 1">
                    <el-tag color="#009CFF" v-if="item.isAccept == 0" type="primary">
                      已报名
                    </el-tag>
                    <el-tag color="#009CFF" round size="large"
                            v-if="item.isAccept == 1 && item.isFinish == 0"
                            type="primary">已签约
                    </el-tag>
                    <el-tag color="#104C92" v-if="item.isFinish == 1" type="primary">已完工
                    </el-tag>

                  </template>
                  <template v-else>
                    <el-tag color="#009CFF" v-if="item.status == 0" type="primary">已发布</el-tag>
                    <el-tag color="#EC425C" v-else-if="item.status == 5" type="primary">已招满</el-tag>
                    <el-tag color="#104C92" v-else-if="item.status == 6" type="primary">已完工</el-tag>
                    <el-tag color="#cccccc" v-else-if="item.status == 9" type="primary">已过期</el-tag>
                  </template>
                  {{ item.name }}
                </div>
                <el-row>
                  <el-col :span="12">
                    <div style="font-size: 14px; line-height: 20px">
                      <el-col :span="10">
                        <i class="el-icon-time"></i> {{ item.pubTime }}
                      </el-col>
                      <el-col :span="14">
                        <i v-if="item.city" class="el-icon-location-outline"></i> {{ item.city }}
                      </el-col>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div style="text-align: right">
                      <el-button v-if="active == 2 && item.status == 0"
                                 style="color: #096CEFFF;background: #FFFFFFFF;border-color: #096CEFFF; width: 88px"
                                 @click="userEnough(item.id)"
                                 size="mini" round plain>已招满
                      </el-button>
                      <el-button style="color: #096CEFFF;background: #FFFFFFFF;border-color: #096CEFFF; width: 88px"
                                 @click="detail(item.id, item.type, item.status, index, item.unitFlag, item.isDraft)"
                                 size="mini" round plain>查看详情
                      </el-button>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div v-else class="noContent">
              <img src="../../assets/img/public/empty_icon.png">
              <div style="width: 100%; text-align: center">暂无内容</div>
            </div>
          </div>
          <pagination
            v-show="total > 0"
            :total="total"
            layout="prev, pager, next"
            :background="false"
            :page.sync="pageNum"
            :limit.sync="pageSize"
            @pagination="pagination"
          />
          <!--          <pagination-->
          <!--            v-show="total > 0"-->
          <!--            :total="total"-->
          <!--            :page.sync="pageNum"-->
          <!--            :limit.sync="pageSize"-->
          <!--            @pagination="pagination"-->
          <!--          />-->
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {myPublishList, myJoinList, userEnough, refuse} from '@api/project'
import personalMenu from '@views/layout/components/personalMenu'

export default {
  name: 'index',
  components: {
    personalMenu
  },
  data() {
    return {
      loadingGoods: true,
      ifHasProduct: false,
      active: '1',
      projectTitleList: [
        {name: '1', title: '我参与的'},
        {name: '2', title: '我发布的'}
      ],
      list: [],
      pageNum: 1,
      pageSize: 5,
      incomeListLoading: false,
      total: 0,
      content: ''
    }
  },
  created() {
    // 我参与的
    this.myJoinList()
  },
  methods: {
    // 已招满
    userEnough(id) {
      this.$confirm('确定项目人员已招满？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        userEnough({id: id}).then(res => {
          if (res.data.code === 200) {
            this.$message.success('操作成功')
            // 刷新数据
            this.myPublishList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },

    search() {
      this.list = []
      this.total = 0
      this.pageNum = 1
      if (this.active === '1') {
        this.myJoinList()
      } else if (this.active === '2') {
        this.myPublishList()
      }
    },
    pagination() {
      this.list = []
      this.total = 0
      if (this.active === '1') {
        this.myJoinList()
      } else if (this.active === '2') {
        this.myPublishList()
      }
    },
    myJoinList() {
      this.loadingGoods = true
      myJoinList({
        type: 2,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        content: this.content
      }).then(res => {
        if (res.data.code === 200) {
          this.loadingGoods = false
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.ifHasProduct = true
            this.list = res.data.data.rows
            this.total = res.data.data.totalRows
            this.pageNum = res.data.data.page
          } else {
            this.ifHasProduct = false
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    tabClick() {
      this.list = []
      this.total = 0
      this.pageNum = 1
      this.content = ''
      if (this.active === '1') {
        this.myJoinList()
      } else if (this.active === '2') {
        this.myPublishList()
      }
    },
    myPublishList() {
      this.loadingGoods = true
      myPublishList({
        type: 2,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        content: this.content
      }).then(res => {
        if (res.data.code === 200) {
          this.loadingGoods = false
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.ifHasProduct = true
            this.list = res.data.data.rows
            this.total = res.data.data.totalRows
            this.pageNum = res.data.data.page
          } else {
            this.ifHasProduct = false
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    detail(id, type, status, index, unitFlag, isDraft) {
      if (this.active === '1') {
        // 我参与的
        if (type === 1) {
          // 标准流程
          if (status === 0) {
            // alert("查看派活信息/待投标")
            this.enterRouter('waitEvaluate', {id: id})
          } else if (status === 1) {
            // alert("评标/待评标")
            this.enterRouter('waitEvaluate', {id: id, isMyRelease: 0})
          } else if (status === 2) {
            // alert("评标结果公示")
            this.enterRouter('evaluateResult', {id: id, isMyRelease: 0})
          } else if (status === 3) {
            // alert("待签约")
            this.enterRouter('isAccepted', {id: id})
          } else if (status === 4) {
            // alert("中标结果公示")
            this.enterRouter('winResult', {id: id, isMyRelease: 0})
          } else if (status === 5) {
            // alert("施工中")
            // 客户端跳转
            if (unitFlag === 2) {
              // 标准
              this.enterRouter('projectDetail', {id: id})
            } else {
              this.enterRouter('underConstruction', {id: id, isMyRelease: 0, projectType: '1'})
            }
          } else if (status === 6) {
            // alert("已完工")
            if (unitFlag === 2) {
              this.enterRouter('projectDetail', {id: id})
            } else {
              this.enterRouter('underConstruction', {id: id, isMyRelease: 0, projectType: '2'})
            }
          }
        } else {
          let simpleProject = this.list[index]
          // 判断简易流程状态type  1.已报名， 2.已签约， 3.已完工
          var simpleType = '0'
          if (simpleProject.isAccept == 0) {
            simpleType = '1'
          } else if (simpleProject.isAccept == 1 && simpleProject.isFinish == 0) {
            simpleType = '2'
          } else if (simpleProject.isFinish == 1) {
            simpleType = '3'
          }
          this.enterRouter('getJobJianYiDetail', {projectId: id, isProject: 1})

          // this.enterRouter('published', {id: id, type: simpleType, isMyRelease: 0})
        }
      } else {
        // 我发布的
        // isDraft：是否草稿：1-是;0-否
        if (isDraft === 1) {
          this.enterRouter('editDraft', {id: id, type: type})
        } else {
          if (type === 1) {
            this.enterRouter('published', {id: id, status: status, isMyRelease: 1})
            return
            if (status === 0) {
              this.enterRouter('distributionInfo', {id: id})
            } else if (status === 1) {
              // alert("评标/待评标")
              this.enterRouter('waitEvaluate', {id: id, isMyRelease: 1})
            } else if (status === 2) {
              // alert("评标结果公示")
              this.enterRouter('evaluateResult', {id: id, isMyRelease: 1})
            } else if (status === 3) {
              // alert("待签约")
              this.enterRouter('waitSign', {id: id})
            } else if (status === 4) {
              // alert("中标结果公示中")
              this.enterRouter('winResult', {id: id, isMyRelease: 1})
            } else if (status === 5) {
              // alert("施工中")
              this.enterRouter('underConstruction', {id: id, projectType: '1', isMyRelease: 1, status: status})
            } else if (status === 6) {
              // alert("已完工")
              this.enterRouter('underConstruction', {id: id, projectType: '2', isMyRelease: 1})
            } else if (status === 7) {
              // alert("撤销")
              this.enterRouter('revocationDetail', {id: id})
            } else if (status === 9) {
              // 流标项目
              this.enterRouter('projectInvalid', {id: id})
            }
          } else {
            // alert("简易流程")
            this.enterRouter('published', {id: id, status: status, isMyRelease: 1})
          }
        }
      }
    },
    getJob() {
      this.enterRouter('getWorkAdvertising')
    },
    apply() {
      this.enterRouter('publishPage')
    }
  }
}
</script>

<style lang="scss">
.el-tabs__nav-wrap::after {
  display: none;
}

.project {
  .el-tag {
    font-size: 12px;
    vertical-align: 10%;
    border-radius: 15px;
    color: #FFFFFF;
    line-height: 23px;
    height: 23px;
  }
}

.el-tabs__item {
  font-size: 16px;
  font-weight: bold;
}

.org-div {
  background: #F9F9F9;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 10px;

  .title {
    font-size: 6;
    font-weight: bold;
    margin-bottom: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

.project {
  border-radius: 5px;
  padding: 10px 20px;
  margin-left: 10px;
  width: 990px;
  margin-top: 20px;
  background-color: #FFFFFF;

  .el-pager li, .el-pagination .btn-next, .el-pagination button:disabled, .el-pagination .btn-prev {
    background: none;
  }

  .el-pager li.active {
    background: #096cef;
    color: #fff;
  }

  .el-pager li {
    min-width: 20px;
    height: 20px;
    line-height: 20px;
    margin: 0 10px;
    font-size: 14px;
  }

  .el-pagination button {
    min-width: 20px;
    height: 20px;
    line-height: 20px;
  }

  .mainContent {
    padding: 24px 0;
    border-bottom: 1px solid #ccc;
    position: relative;

    &:last-of-type {
      border-width: 0;
    }

    .project-title {
      font-size: 24px;
      margin-bottom: 16px;
    }

    .information {
      margin-bottom: 16px;
      color: #333333;
      font-size: 16px;

      span {
        color: #999999;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .button {
      position: absolute;
      right: 0;
      bottom: 28px;
    }
  }
}
</style>
